import { render, staticRenderFns } from "./ModalSubstituicaoVeiculo.vue?vue&type=template&id=671f8445"
import script from "./ModalSubstituicaoVeiculo.vue?vue&type=script&lang=js"
export * from "./ModalSubstituicaoVeiculo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports